module.exports = __webpack_public_path__ + "static/media/tr808_clap.dd3d636a.wav";